import React, { useState, useEffect } from "react";
import Footer from "../components/footer/footer";
import Header from "../components/header/header";
import Error from "./Error";
import Models from "./Models";
import Users from "./Users";
import Tools from "./Tools";
import Discount from "./Discount";
import Currency from "./Currency";
import Reports from "./Reports";
// import Views from "./Views";
// import Drawings from "./Drawings";
import * as miscAction from "../actions/miscAction";
import * as appAction from "../actions/appAction";
import { connect } from "react-redux";
import DMTabContainer from "../components/common/controls/DMTabContainer";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { HasPermission, userSecurityRole } from "../utilities/applicationutils";
// import * as dataDescriptionAction from "../actions/dataDescriptionAction";
import Loading from "../components/Loading/Loading";
import AppRoutes from "../routers/routes";
import PageNotFound from "../hooks/pageNotFound";
var CONTROLS_DATA = require("./ControlsData.json");

const Main = ({
  permissions,
  miscState,
  onTabSelected,
  setSnackBar,
  getConfigGroups,
  getLoggedUserRoleAction,
  getLoggedUserIdAction,
  userRole,
  onModelSelected,
  userId,
  breadCrumbSettingAction,
  breadCrumb,
  userName
}) => {
  console.log('main permission',userRole, userName);
  const [selectedTab, setSelectedTab] = useState(0);
  const [userRolePermission, setUserRolePermission] = useState(null);
  const [tabs, setTabs] = useState(CONTROLS_DATA.SCREENS.TAB_NAMES);
  const [adminTabs, setAdminTabs] = useState(CONTROLS_DATA.SCREENS.TAB_NAMES);
  const [regionTabs, setRegionTabs] = useState(
    CONTROLS_DATA.SCREENS.REGIONS_LEVEL_TAB_NAMES
  );
  const [salesOfficeTabs, setSalesOfficeTabs] = useState(
    CONTROLS_DATA.SCREENS.SALES_OFFICE_LEVEL_TAB_NAMES
  );
  const [snackbarDetails, setSnackBarDetails] = useState(miscState.snackbar);
  const [loading, setLoading] = useState(false);
  const [bredCrumbData, setBredCrumbData] = useState(breadCrumb != "" ? breadCrumb : "ADMIN")
  const readPermission = HasPermission(permissions);

  //const userRolePermission = userSecurityRole(securityLevel);

  const getContainer = (selectedTab,userRolePermission) => {
    // switch (selectedTab) {
    //   case 0:
    //     return <Models />;
    //   case 1:
    //     return <Users />;
    //   case 2:
    //     return <Tools />;
    //   case 3:
    //     return <Discount />;
    //   case 4:
    //     return <Currency />;
    //   case 5:
    //     return <Reports />;
    // }
    return <AppRoutes selectedTab={selectedTab} userInfo={userRolePermission} />;
  };

  /* Enable/Disable tabs */
  const updateTabs = (seletedTab, data) => {
    const updateTabs = data.map((item, index) => {
      if (seletedTab !== index) {
        return { ...item, disabled: false };
      }
      return item;
    });
    return updateTabs;
  };

  useEffect(() => {
    const updateModelSelected = async(userRole) => {
      await onModelSelected(userRole);
    }
    updateModelSelected(userRole);
  },[userRole])
  useEffect(() => {
    console.log('checking miscState in main ===>',miscState);
    setSelectedTab(miscState.selectedTab);
    if(userRole === "ADMIN"){
      if (miscState.selectedTab === 0) {
        if(miscState.selectedModel === "ADMIN"){
          setTabs(CONTROLS_DATA.SCREENS.TAB_NAMES);
        }
        else if(miscState.selectedModel === "REGION"){
          setTabs(CONTROLS_DATA.SCREENS.REGIONS_LEVEL_TAB_NAMES);
        }
        else{
          setTabs(CONTROLS_DATA.SCREENS.SALES_OFFICE_LEVEL_TAB_NAMES);
        }
      } else {
        const tabsChanged = updateTabs(
          miscState.selectedTab,
          tabs
        );
        setTabs(tabsChanged);
      }
    }
    else if(userRole === "REGION"){
      if (miscState.selectedTab === 0) {
        if(miscState.selectedModel === "ADMIN"){
          setTabs(CONTROLS_DATA.SCREENS.TAB_NAMES);
        }
        else if(miscState.selectedModel === "REGION"){
          setTabs(CONTROLS_DATA.SCREENS.REGIONS_LEVEL_TAB_NAMES);
        }
        else{
          setTabs(CONTROLS_DATA.SCREENS.SALES_OFFICE_LEVEL_TAB_NAMES);
        }
      } else {
        const tabsChanged = updateTabs(
          miscState.selectedTab,
          tabs
        );
        setTabs(tabsChanged);
      }
    }
    else{
      if (miscState.selectedTab === 0) {
        if(miscState.selectedModel === "ADMIN"){
          setTabs(CONTROLS_DATA.SCREENS.TAB_NAMES);
        }
        else if(miscState.selectedModel === "REGION"){
          setTabs(CONTROLS_DATA.SCREENS.REGIONS_LEVEL_TAB_NAMES);
        }
        else{
          setTabs(CONTROLS_DATA.SCREENS.SALES_OFFICE_LEVEL_TAB_NAMES);
        }
      } else {
        const tabsChanged = updateTabs(
          miscState.selectedTab,
          tabs
        );
        setTabs(tabsChanged);
      }
    }
  }, [miscState.selectedTab,userRole]);

  useEffect(()=>{
    if(permissions?.emailAddress){
      setLoading(true)
     const fetchRoleAndId = async() => {
      await  getLoggedUserRoleAction(permissions.emailAddress);
      // if((userRole === "REGION" && permissions?.emailAddress) || (userRole === "SALES_OFFICE" && permissions?.emailAddress)){
      //     await getLoggedUserIdAction(permissions.emailAddress);
      // }
      setLoading(false);
     }
     fetchRoleAndId();
    }
  },[getLoggedUserRoleAction,permissions]);

  useEffect(()=>{
    if((userRole === "REGION" && permissions?.emailAddress) || (userRole === "SALES_OFFICE" && permissions?.emailAddress)){
      setLoading(true);
      localStorage.setItem("userName",userName);
      const fetchUserId = async() => {
        await getLoggedUserIdAction(permissions.emailAddress);
        await breadCrumbSettingAction(userName);
        setLoading(false);
      }
      fetchUserId();
    }
    else{
      localStorage.setItem("userName","Admin");
    }
  },[permissions,userRole,userName])

  useEffect(() => {
    setBredCrumbData(breadCrumb);
  },[breadCrumb]);

  useEffect(() => {
    console.log('check role and id',userRole, userId,miscState)
    setUserRolePermission({
      userRole:userRole,
      userId:userId
    })
    if(userRole === "REGION"){
      localStorage.setItem("regionIdValue",userId);
    }
    if(userRole === "SALES_OFFICE"){
      localStorage.setItem("salesOfficeValue",userId);
      console.log('checking sales office id',localStorage.getItem("salesOfficeValue"));
    }
  },[userRole,userId])

  useEffect(() => {
    console.log('checking miscState',miscState);
    if (miscState.selectedModel === "ADMIN") {
      setTabs(
        adminTabs.map((t) => {
          return { ...t, disabled: false };
        })
      );
    }
    else if(miscState.selectedModel === "REGION"){
      setTabs(
        regionTabs.map((t) =>{
          return { ...t, disabled: false}
        })
      )
    }
    else{
      setTabs(
        salesOfficeTabs.map((t) => {
          return { ...t, disabled: false };
        })
      );
    }
  }, [miscState.selectedModel]);

  // useEffect(() => {
  //   if (miscState?.selectedModel) getConfigGroups(miscState.selectedModel);
  // }, [miscState.selectedModel]);

  useEffect(() => {
    setSnackBarDetails(miscState.snackbar);
  }, [miscState.snackbar]);

  return (
    <>
      <Loading open={loading} />
      <Header permission={permissions} bredCrumbData={bredCrumbData}/>
      {readPermission ? (
        // (userRole === "ADMIN") ? (
        //   <>
        //     <DMTabContainer
        //       tabs={tabs}
        //       defaultActiveTab={selectedTab}
        //       onTabChange={onTabSelected}
        //       alignment={"center"}
        //     />
        //     <div>{getContainer(selectedTab,userRolePermission)}</div>
        //   </>
        // ) : (userRolePermission?.userRole === "REGION") ? (
        //   <>
        //     <DMTabContainer
        //       tabs={regionTabs}
        //       defaultActiveTab={selectedTab}
        //       onTabChange={onTabSelected}
        //       alignment={"center"}
        //     />
        //     <div>{getContainer(selectedTab,userRolePermission)}</div>
        //   </>
        // ) : (
        //   <>
        //     <DMTabContainer
        //       tabs={salesOfficeTabs}
        //       defaultActiveTab={selectedTab}
        //       onTabChange={onTabSelected}
        //       alignment={"center"}
        //     />
        //     <div>{getContainer(selectedTab,userRolePermission)}</div>
        //   </>
        // )
        <>
          <DMTabContainer
            tabs={tabs}
            defaultActiveTab={selectedTab}
            onTabChange={onTabSelected}
            alignment={"center"}
          />
          <div>{getContainer(selectedTab,userRolePermission)}</div>
        </>
      ) : (
        <>
        <PageNotFound />
        </>
      )}
      <Snackbar
        open={snackbarDetails?.show}        
        onClose={() => setSnackBar(false, "", "")}
        style={{ zIndex: "111111" }}
      >
        <Alert
          onClose={() => setSnackBar(false, "", "")}
          severity={snackbarDetails?.severity}
        >
          {snackbarDetails?.message}
        </Alert>
      </Snackbar>
      <Footer />
    </>
  );
};
const mapStateToProps = (state) => ({
  miscState: state.misc,
  userRole: state.loggedInUserInfo.loggedInUserInfo?.userRole || null,
  userId: state.loggedInUserInfo.loggedInUserInfo?.userId || null,
  userName: state.loggedInUserInfo.loggedInUserInfo?.userName || null,
  breadCrumb: state.misc.bredCrumb
});

const mapDispatchToProps = (dispatch) => {
  return {
    onTabSelected: (tabId) => dispatch(miscAction.onTabSelected(tabId)),
    // getConfigGroups: async (requestPayload) =>
    // dispatch(dataDescriptionAction.getConfigGroups(requestPayload)),
    setSnackBar: (show, severity, message) =>
      dispatch(miscAction.setSnackBar(show, severity, message)),
    getLoggedUserRoleAction: (email) => dispatch(appAction.getLoggedUserRoleAction(email)),
    getLoggedUserIdAction: (email) => dispatch(appAction.getLoggedUserIdAction(email)),
    onModelSelected: (userRole) => dispatch(miscAction.onModelSelected(userRole)),
    breadCrumbSettingAction: (bredCrumbUrl) => dispatch(miscAction.breadCrumbSettingAction(bredCrumbUrl))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Main);
